var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesseract({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_386",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28860",
    "data-name": "Group 28860",
    transform: "translate(-4837 6376)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4837, -6376)",
    filter: "url(#Ellipse_386)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386-2",
    "data-name": "Ellipse 386",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_13_",
    "data-name": "svgexport-17 (13)",
    transform: "translate(4859 -6357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49710",
    "data-name": "Path 49710",
    d: "M41.122,4.324,30.684,0,20.245,4.324,16.9,14.62l4.07,9.862,9.717,4.025L41.122,25.2l4.324-10.438Z",
    transform: "translate(-15.922)",
    fill: "#00d7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49711",
    "data-name": "Path 49711",
    d: "M25.2,95.854l-10.438,4.323L4.323,95.854,0,85.415,4.323,74.977,2.058,85.415,5.779,94.4l8.983,3.721Z",
    transform: "translate(0 -70.654)",
    fill: "#00aadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49712",
    "data-name": "Path 49712",
    d: "M22.143,17.819l7.381-3.057h0L22.143,11.7,25.2,4.324,17.819,7.381,14.762,0h0L11.7,7.381,4.324,4.324,7.381,11.7,0,14.762H0l7.381,3.057L4.324,25.2,11.7,22.143l3.057,7.381h0l3.057-7.381L25.2,25.2Z",
    fill: "#30c7f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49713",
    "data-name": "Path 49713",
    d: "M141.5,135.381l1.266,3.057L139.7,139.7l-1.267,3.057-3.057-1.266-3.057,1.266-1.266-3.057L128,138.438l1.267-3.057L128,132.324l3.057-1.266L132.324,128l3.057,1.267L138.438,128l1.267,3.057,3.057,1.266Z",
    transform: "translate(-120.619 -120.619)",
    fill: "#00aadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49714",
    "data-name": "Path 49714",
    d: "M159.134,157.343l3.057-1.266h0l-3.057-1.266,1.266-3.057-3.057,1.266-1.266-3.057h0l-1.266,3.057-3.057-1.266,1.266,3.057-3.057,1.266h0l3.057,1.266-1.266,3.057,3.057-1.266,1.266,3.057h0l1.266-3.057L160.4,160.4Z",
    transform: "translate(-141.315 -141.315)",
    fill: "#51c7ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49715",
    "data-name": "Path 49715",
    d: "M208.605,206.125l.487,1.176-1.176.487a.238.238,0,0,0-.129.129l-.487,1.176-1.176-.487a.238.238,0,0,0-.182,0l-1.176.487-.487-1.176a.238.238,0,0,0-.129-.129l-1.176-.487.487-1.176a.238.238,0,0,0,0-.182l-.487-1.176,1.176-.487a.237.237,0,0,0,.129-.129l.487-1.176,1.176.487a.238.238,0,0,0,.182,0l1.176-.487.487,1.176a.238.238,0,0,0,.129.129l1.176.487-.487,1.176A.238.238,0,0,0,208.605,206.125Z",
    transform: "translate(-191.273 -191.273)",
    fill: "#b3e5ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesseract);
export default __webpack_public_path__ + "static/media/tesseract.95e410d91605490a838d42336fb7a1f9.svg";
export { ForwardRef as ReactComponent };